import { memo } from 'react';

import { ReactComponent as LogoIcon } from 'assets/images/logo.svg';
import { ReactComponent as AppNameIcon } from 'assets/images/app-name.svg';

import styles from './styles.module.scss';

type Props = {
  compact?: boolean;
};

export const Logo: React.FC<Props> = memo(function Logo({ compact = false }) {
  return (
    <div className={compact ? styles.compact_container : styles.container}>
      <LogoIcon />
      {!compact && <AppNameIcon />}
    </div>
  );
});
